import JSZip from 'jszip'
import JSZipUtils from 'jszip-utils'
import FileSaver from 'file-saver'

function addNumberToFileName (name, num) {
  const fileArr = name.split('.').reverse()
  fileArr[1] = `${fileArr[1]}(${num})`
  return fileArr.reverse().join('.')
}
function group (array, subGroupLength) {
  var index = 0
  var newArray = []

  while (index < array.length) {
    newArray.push(array.slice(index, index += subGroupLength))
  }

  return newArray
}

/**
 * @param {*} name 下载zip名称
 * @param {*} urlArr 文件类型：{url: 链接, name：文件名称}
 */
export default function downloadZip (name, urlArr) {
  let newArray = group(urlArr, 500)
  newArray.forEach((e, i) => {
    setTimeout(() => {
      let zip = new JSZip()
      let count = 0
      let fileName = {}
      e.forEach(item => {
        JSZipUtils.getBinaryContent(item.url, function (err, data) {
          if (err) {
            throw err // or handle the error
          }
          if (fileName[item.name] !== undefined) {
            fileName[item.name]++
          } else {
            fileName[item.name] = 0
          }
          zip.file(
            fileName[item.name] === 0
              ? item.name
              : addNumberToFileName(item.name, fileName[item.name]),
            data, { binary: true })
          count++
          if (count === e.length) {
            zip.generateAsync({ type: 'blob' }).then(function (content) {
              FileSaver.saveAs(content, `${name}${i > 0 ? i : ''}.zip`)
            })
          }
        })
      })
    }, i * 1000)
  })
}
